import * as types from '../constants'

const initialState = {
  estados: [],
  neighborhood: {},
}

const locations = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_LOCATIONS:
      return { ...state, estados: action.payload }
    case types.UPDATE_NEIGHBORHOOD:
      return { ...state, neighborhood: action.payload }
    default:
      return state
  }
}

export default locations



// WEBPACK FOOTER //
// ./src/store/locations/reducer.js